import {
  bool,
  number,
  oneOf,
  shape,
  string,
} from 'prop-types';

export default shape({
  name: string,
  description: string,
  isInEventUseTree: bool.isRequired,
  frequency: oneOf(['Always', 'Sometimes']).isRequired,
  image: string.isRequired,
  id: number.isRequired,
});